export default __webpack_public_path__ + "static/media/btn-call-off.761835cb.png";